var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "inquiry-class",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Insurance.LiabilityInsuranceInquiry"),
        "append-to-body": "",
        fullscreen: true,
        "close-on-click-modal": false,
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            background: "grey",
            padding: "1px",
            "flex-grow": "1",
            height: "100%"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-left": "20%",
                "padding-left": "15%",
                width: "60%",
                background: "white",
                height: "100%",
                "overflow-y": "auto"
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "padding-top": "1px" },
                  attrs: { model: _vm.form }
                },
                [
                  _c(
                    "p",
                    { staticStyle: { color: "red", "margin-top": "5px" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Insurance.InquiryForQuestionnaireContent")
                        )
                      )
                    ]
                  ),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("Insurance.AfterFillingQuestionnaire"))
                    )
                  ]),
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        "1、" + _vm.$t("Insurance.ServiceProviderSelection")
                      )
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "520px" },
                      attrs: {
                        label: _vm.$t("SystemMaintenance.ServiceProviders"),
                        "label-width": "150px",
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "static-options": _vm.insuranceAgentList,
                          "tag-value": "code",
                          filterable: "",
                          disabled: !!_vm.form.uuid,
                          "filter-type": "global",
                          cache: false,
                          clearable: false,
                          "default-value": _vm.form.insuranceAgent
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.insuranceAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("h4", [
                    _vm._v(
                      _vm._s("2、" + _vm.$t("Insurance.ApplicantInformation"))
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "520px" },
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Contact"),
                        "label-width": "150px",
                        required: ""
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          "method-params": {
                            officeId: _vm.form.branchId,
                            active: true
                          },
                          "default-value": _vm.form.contactUser || "",
                          clearable: false
                        },
                        on: {
                          change: function(p) {
                            return _vm.changeConcatUser(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "520px" },
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ContactNumber"),
                        "label-width": "150px",
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.contactTel,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contactTel", $$v)
                          },
                          expression: "form.contactTel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "520px" },
                      attrs: {
                        label: _vm.$t("Partners.emailAddress2"),
                        "label-width": "150px"
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.contactAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contactAddress", $$v)
                          },
                          expression: "form.contactAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _c("h4", [
                    _vm._v(
                      _vm._s("3、" + _vm.$t("Insurance.RegisteredAndBusiness"))
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "520px" },
                      attrs: {
                        label: _vm.$t("Insurance.RegisteredName"),
                        "label-width": "150px",
                        required: ""
                      }
                    },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          "office-id": Number(_vm.form.registeredIdx || 0),
                          clearable: false
                        },
                        on: {
                          change: function(p) {
                            return _vm.changeRegisteredIdx(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "520px" },
                      attrs: {
                        label: _vm.$t("Insurance.RegisteredAddress"),
                        "label-width": "150px",
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "370px" },
                        model: {
                          value: _vm.form.registeredAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "registeredAddress", $$v)
                          },
                          expression: "form.registeredAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "520px" },
                      attrs: {
                        label: _vm.$t("Insurance.BusinessName"),
                        "label-width": "150px"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "370px" },
                        model: {
                          value: _vm.form.businessName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "businessName", $$v)
                          },
                          expression: "form.businessName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "520px" },
                      attrs: {
                        label: _vm.$t("Insurance.BusinessAddress"),
                        "label-width": "150px"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "370px" },
                        model: {
                          value: _vm.form.businessAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "businessAddress", $$v)
                          },
                          expression: "form.businessAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _c("h4", [
                    _vm._v(
                      _vm._s("4、" + _vm.$t("Insurance.InquiryQuestionnaire"))
                    )
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "10px", width: "520px" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticStyle: {
                            float: "left",
                            "margin-right": "10px"
                          },
                          attrs: {
                            action: "",
                            multiple: "",
                            accept: ".doc, .docx, .pdf",
                            "auto-upload": false,
                            "show-file-list": false,
                            "on-change": _vm.toChooseFile
                          }
                        },
                        [
                          _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.SelectFile")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.downloadTemplate }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.DownloadTemplate")))]
                      ),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%", "margin-top": "5px" },
                          attrs: { data: _vm.fileList, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "dateCreated",
                              label: _vm.$t("SeaExport.SubmissionDateTime")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("Message.File") },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "i",
                                      {
                                        staticStyle: { color: "#0A0AFF" },
                                        on: {
                                          click: function($event) {
                                            return _vm.downloadFile(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.fileName))]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("SeaExport.Operation"),
                              width: "50px"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("i", {
                                      staticClass: "el-icon-delete",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFile(scope.row)
                                        }
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("h4", [
                    _vm._v(
                      _vm._s("5、" + _vm.$t("Insurance.ServiceProviderReply"))
                    )
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "10px" } },
                    _vm._l(_vm.replyList, function(item) {
                      return _c(
                        "el-steps",
                        {
                          key: item.replyTime,
                          attrs: {
                            direction: "vertical",
                            active: _vm.replyList.length
                          }
                        },
                        [
                          _c("el-step", { attrs: { icon: "''" } }, [
                            _c(
                              "div",
                              { attrs: { slot: "title" }, slot: "title" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Insurance.RecoveryTime") +
                                        item.replyTime
                                    )
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              { attrs: { slot: "title" }, slot: "title" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Insurance.ReplyContent") +
                                        item.content
                                    )
                                  )
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("h4", [
                    _vm._v(_vm._s("6、" + _vm.$t("SeaExport.Remarks")))
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "520px", "margin-left": "10px" },
                    attrs: { type: "textarea", autosize: { minRows: 4 } },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveInquiry } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }